import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import trafikArtis from "../../assets/img/kb-mobile.png"
import sorunlar from "../../assets/img/kb-sorunlar.png"
import kuruyemisborsasi from "../../assets/img/kb-new.png"
import cozum from "../../assets/img/kb-cozumler.png"
import OtherCaseStudy from "../../components/other-case"

import aysima from "../../assets/img/teams/35.jpg"
import myildirim from "../../assets/img/teams/22.jpg"
import serife from "../../assets/img/teams/20.jpg"
import bengu from "../../assets/img/teams/17.jpg"
import zeynep from "../../assets/img/teams/33.jpg"




const ReferancesDetail = () => (
    <Layout>
        <SEO title="Kuruyemiş Borsası Success Story" />
        <div className="referances-detail py60 container">
            <div className="col-md-6 detail-left">
                <b>SUCCESS STORY</b>
                <h1>Kuruyemiş Borsası</h1>
                <p style={{ maxWidth: 450 }}>Kuruyemiş Borsası — brought to life by an established organization operating in the nut industry since 1994 and a team renowned for its achievements in digital marketing — delivers a wide variety of nuts, one of nature's most generous gifts, to buyers through its e-commerce platform.</p>
                <p style={{ maxWidth: 450 }}>As flatart, we first built the brand strategy for Kuruyemiş Borsası, then carried out work in website design, SEO and SEM, and implemented website improvements at the right moments — all with a focus on achieving a sustainable growth trajectory.</p>
                <a className="svgLink" target="_blank" href="https://www.kuruyemisborsasi.com/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
                    <g id="Group_11" data-name="Group 11" transform="translate(-432 -2296)">
                        <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(432 2296)" fill="none" stroke="#000" strokeWidth="3">
                            <circle cx="24" cy="24" r="24" stroke="none" />
                            <circle cx="24" cy="24" r="22.5" fill="none" />
                        </g>
                        <path id="Path_80" data-name="Path 80" d="M422.384,556.893l-2.14,2.154,7.736,7.846-7.736,7.846,2.14,2.154,9.86-10Z" transform="translate(30.756 1753.107)" />
                    </g>
                </svg>
                    <span>kuruyemisborsasi.com</span></a>

            </div>
            <div className="col-md-6 referances-boxs">
                <div className="boxs" style={{ marginBottom: '0' }}>
                    <div className="box">
                        <span>+%186</span>
                        <p>Conversion rate increase.</p>
                    </div>
                    <div className="box">
                        <span>+%34</span>
                        <p>Annual revenue increase</p>

                    </div>
                    <div className="box">
                        <span>+%18</span>
                        <p>Session duration increase.</p>
                    </div>

                </div>
                <div className="provided">
                    <h3>Services Provided</h3>
                    <div className="provided-box">
                        <div className="box">
                            <Link to="/ui-ux-design/"></Link>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                                <g id="Icons-_-Design-_-Sketch" data-name="Icons-/-Design-/-Sketch" transform="translate(0.015 -0.307)">
                                    <rect id="bound" width="76" height="76" transform="translate(-0.015 0.307)" fill="none" />
                                    <path id="Path-48" d="M13.728,3H58.276L71,18.91H1Z" transform="translate(2.182 6.546)" fillRule="evenodd" opacity="0.3" />
                                    <path id="Path-48-Copy" d="M71,8,36,46.184,1,8Z" transform="translate(2.182 17.456)" fillRule="evenodd" />
                                </g>
                            </svg>
                            UI&amp;UX Design
                        </div>
                        <div className="box">
                            <Link to="/search-engine-optimization/"></Link>
                            <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                                    <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                                    <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                                    <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                                </g>
                            </svg>
                            SEO
                        </div>
                    </div>
                </div>
                <div className="project-details">
                    <h3>Impressum</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Project Manager:</li>
                            <li>SEO Specialist:</li>
                            <li>Digital Ads Specialist:</li>
                            <li>Content Writer:</li>
                            <li>Website Software Development:</li>

                        </ul>
                        <ul>
                            <li><img src={myildirim} alt="Murathan Yıldırım" />Murathan Yıldırım</li>
                            <li><img src={bengu} alt="Bengü Dinçer" />Bengü Dinçer</li>
                            <li><img src={serife} alt="Şerife Aytekin" />Şerife Aytekin</li>
                            <li><img src={aysima}  alt="Aysima Bakırcılar" />Aysima Bakırcılar</li>
                            <li><img src={zeynep} alt="Zeynep Oralel" />Zeynep Oralel</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
        <div className="content-section content row py60" >
                <div className="col-md-7">
                    <img  src={kuruyemisborsasi} alt="Kuruyemiş Borsası website"/>
                </div>
                <div className="col-md-5">
                    <span className="small">Success Story</span>
                    <p style={{ maxWidth: 400 }} >Since the day we started working together, we have significantly increased brand awareness for Kuruyemiş Borsası — and while expanding the audience it reaches, we also ensured that the number of repeat orders multiplied.</p>

                </div>
            </div>
            <div className="content-section content row" id="eCantaCozum">
                <div className="col-md-6">
                    <span className="small">Success Story</span>
                    <h3>Challenges</h3>
                    <p style={{ maxWidth: 450 }} >- Low e-commerce conversion rate relative to acquired traffic,</p>
                    <p style={{ maxWidth: 450 }} >- Monthly revenue growth not reaching the desired level,</p>
                    <p style={{ maxWidth: 450 }} >- Website visibility in search results not meeting expectations,</p>
                    <p style={{ maxWidth: 450 }} >- Average session duration being below the ideal level.</p>
                </div>
                <div className="col-md-6">
                    <img src={sorunlar} alt="Desktop menu screen"/>
                </div>
            </div>
            <div className="content-section content row py60" >
                <div className="col-md-6">
                    <img className="pr100" src={cozum} alt="Desktop menu screen"/>
                </div>
                <div className="col-md-6">
                    <span className="small">Success Story</span>
                    <h3>Solutions</h3>
                    <p style={{ maxWidth: 500 }} >- The website design was developed to be more user-centric.</p>
                    <p style={{ maxWidth: 500 }} >- Strategies for brand loyalty were created and implemented.</p>
                    <p style={{ maxWidth: 500 }} >- SEO content was crafted with a focus on user trends.</p>
                    <p style={{ maxWidth: 500 }} >- Technical SEO requirements were completed.</p>
                    </div>
            </div>

            <div className="text-center content py60">
                <span className="small">Success Story</span>
                <h2 style={{ margin: '7px auto 10px', maxWidth: 900 }}><b>In 1 year</b>, a <b>%186</b> e-commerce conversion rate increase was achieved through organic traffic</h2>
                <p style={{ maxWidth: 1100 }} >High-quality traffic was obtained through an SEO-focused content marketing strategy. This enabled organic sales, and during the August 2020 – August 2021 period, a 186% increase in e-commerce conversion rate was achieved compared to the previous period.</p>
            </div>

            <div className="content-section content row" >
                <div className="col-md-6">
                    <img  src={trafikArtis} alt="Kuruyemiş Borsası mobile traffic analytics" />
                </div>
                <div className="col-md-6">

                    <h3 style={{ maxWidth: 480, fontSize: 25, textAlign:"right" }}>Annual revenue obtained through organic traffic <b>grew by 34%</b></h3>
                    <p style={{ maxWidth: 480, textAlign:"right" }} >By redesigning the website to meet user needs and completing the technical SEO requirements, annual revenue increased by 34% during the August 2020 – August 2021 period compared to the previous period.</p>
                    <h3 style={{ maxWidth: 480, fontSize: 25, textAlign:"right"}}>Average session duration <b>increased by 18% in 1 year.</b></h3>
                    <p style={{ maxWidth: 480,  textAlign:"right"}} >Through SEO-focused content marketing efforts and fulfillment of technical SEO requirements, a web experience aligned with the expectations of internet users was delivered. This led online visitors to spend more time on the Kuruyemiş Borsası website. As a result, during the August 2020 – August 2021 period, an 18% increase in average session duration was achieved compared to the previous period.</p>

                </div>

            </div>

        </div>

        <OtherCaseStudy />

        <Checkup />
    </Layout >
)

export default ReferancesDetail
